import * as styles from './index.module.scss';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

import { SiteContext } from '@/contexts/site-context';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

const getImage = (name) => {
  switch (name) {
    case 'AC Contractors':
      return `https://s3.amazonaws.com/callapro.com/category/ac.png`;
    case 'Appliance Repair':
      return `https://s3.amazonaws.com/callapro.com/category/appliance_repair.png`;
    case 'Auto Glass':
      return `https://s3.amazonaws.com/callapro.com/category/auto_glass.png`;
    case 'Bathroom Remodeling':
      return `https://s3.amazonaws.com/callapro.com/category/bathroom.png`;
    case 'Electricians':
      return `https://s3.amazonaws.com/callapro.com/category/electrician.png`;
    case 'Exterminators':
      return `https://s3.amazonaws.com/callapro.com/category/exterminator.png`;
    case 'Flea Exterminators':
      return `https://s3.amazonaws.com/callapro.com/category/flea-exterminators.png`;
    case 'Heating Contractors':
      return `https://s3.amazonaws.com/callapro.com/category/heating.png`;
    case 'Home Remodeling':
      return `https://s3.amazonaws.com/callapro.com/category/home-remodeling.png`;
    case 'HVAC Contractors':
      return `https://s3.amazonaws.com/callapro.com/category/hvac.png`;
    case 'Landscapers':
      return `https://s3.amazonaws.com/callapro.com/category/landscaper.png`;
    case 'Locksmiths':
      return `https://s3.amazonaws.com/callapro.com/category/locksmith.png`;
    case 'Mold Remediation':
      return `https://s3.amazonaws.com/callapro.com/category/mold.png`;
    case 'Painters':
      return `https://s3.amazonaws.com/callapro.com/category/painter.png`;
    case 'Plumbers':
      return `https://s3.amazonaws.com/callapro.com/category/plumber.png`;
    case 'Roofers':
      return `https://s3.amazonaws.com/callapro.com/category/roofers.png`;
    case 'Siding Contractors':
      return `https://s3.amazonaws.com/callapro.com/category/siding-contractors.png`;
    case 'Solar Installation':
      return `https://s3.amazonaws.com/callapro.com/category/solar-installation.png`;
    case 'Tree Service':
      return `https://s3.amazonaws.com/callapro.com/category/tree-service.png`;
    case 'Water & Fire Damage':
      return `https://s3.amazonaws.com/callapro.com/category/water.png`;
    case 'Window Installers':
      return `https://s3.amazonaws.com/callapro.com/category/window.png`;
    default:
      return `https://s3.amazonaws.com/callapro.com/category/default.png`;
  }
};

const PopularCategories = () => {
  const [site, setSite] = React.useContext(SiteContext);

  return (
    <div className={styles['popular-categories-container']}>
      <div className="container">
        <h2>Professional Services</h2>
        <div className={styles['images-container']}>
          {CATEGORY_SUBSETS.filter((category) => !category.exclude_from_popular_categories).map((category) => (
            <Link href={`/${category.url_slug}`} key={category.name} className={styles['images-container-item']} onClick={() => setSite({ ...site, carouselNav: true })}>
              <div className={styles['image-container']}>
                <Image
                  src={getImage(category.name)}
                  alt={category.name}
                  width={1200}
                  height={1200}
                  quality={80}
                  placeholder="blur"
                  blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg=="
                />
              </div>
              <label>{category.name.indexOf('HVAC') > -1 ? category.name : category.name.replace('AC', 'A/C')}</label>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PopularCategories;
